// extracted by css-extract-rspack-plugin
export default {"scaledDot":"EntryStatusIcon-module__scaledDot__JvagF"};